import { z } from 'zod';

import { CountryCodeSchema } from '@utility/checkout-utils';

export const GlobalApiCountrySchema = z.object({
  country: CountryCodeSchema,
});

export const GlobalApiInstitutionsCountriesSchema = z
  .array(GlobalApiCountrySchema)
  .min(1);
